import React from 'react';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
export const BenefitYearFilter = ({
  benefitYearProps,

  benefitYearChangeHandler: onChange,
}) => {
  return (
    <AutoSuggestionSelectComponent
      options={benefitYearProps.options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="benefir-year-filter height-32 view-member"
      value={benefitYearProps.selectedBenefitYear}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
